import { Autocomplete, Checkbox, FormGroup, InputLabel, TextField } from '@mui/material';
import * as React from 'react';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CloseIcon from '@mui/icons-material/Close';
import { ShippingLine } from 'types/Shipping';
import { useQuery } from '@tanstack/react-query';
import { fetchShippingLines } from 'services/clients/shippingLine';
import { useRegion } from 'common/hooks/region';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface Props {
  defaultValue?: string[];
  onChange: (events: React.SyntheticEvent, values: ShippingLine[]) => void;
  label?: string;
  className?: string;
}

export const ShippingLineAutoComplete: React.FC<Props> = (props) => {
  const { defaultValue: requestedDefaultValue, onChange, label, className } = props;
  const region = useRegion();

  const shippingLineQuery = useQuery({
    queryKey: ['shippingLines', region.code],
    queryFn: ({ signal }) => fetchShippingLines({ signal, portCollectionCodes: [region.code] }),
  });

  const defaultValue = (shippingLineQuery.data || []).filter((ssl) =>
    (requestedDefaultValue || []).includes(ssl.key)
  );

  return (
    <FormGroup className={className}>
      {label && (
        <InputLabel className="relative transform-none text-gray-900 font-medium pb-1">
          {label}
        </InputLabel>
      )}
      <Autocomplete
        multiple
        disablePortal
        fullWidth
        noOptionsText="No shipping line"
        disableCloseOnSelect
        options={shippingLineQuery.data || []}
        isOptionEqualToValue={(option, value) => {
          return option.key === value.key;
        }}
        getOptionLabel={(option) => option.name}
        defaultValue={defaultValue}
        loading={shippingLineQuery.isLoading}
        onChange={onChange}
        renderOption={(optionProps, option, { selected }) => (
          <li {...optionProps} key={option.key}>
            <Checkbox icon={icon} size="small" checkedIcon={checkedIcon} checked={selected} />
            <p className="font-medium  text-sm">{option.name}</p>
          </li>
        )}
        ChipProps={{
          deleteIcon: <CloseIcon style={{ fontSize: 14, margin: 0 }} />,
        }}
        renderInput={(params) => (
          <TextField {...params} size="small" variant="outlined" placeholder="Shipping Line" />
        )}
      />
    </FormGroup>
  );
};
ShippingLineAutoComplete.displayName = 'Selectors.ShippingLineAutoComplete';
